<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { openExtensionFromTodo } from "../../../../utils/extension.js";
  import { todosModalItemStore } from "../stores";

  const onclick = () =>
    openExtensionFromTodo({
      url: $todosModalItemStore?.data?.url,
      extensionId: $userStore.extensionId,
      todoExtensionVersion: $userStore.todoExtensionVersion,
    });
</script>

<ButtonWithTooltip
  kind="primary"
  leadingIcon="fa-brands fa-linkedin"
  class="flex-1"
  {onclick}
  target="_blank"
  size="large"
  placement="top"
>
  <span slot="tooltip"
    >Manually send Connection Request <br />on LinkedIn to continue outreach</span
  >
  Send Connection Request
</ButtonWithTooltip>
